import "./action-header.scss";
import { Grid } from "@mui/material";

interface Props {
  heading: string;
  isbuttonRequired?: boolean;
  buttonName?: string;
  buttonImg?: string;
  handleClick?: any;
  className?: any;
  isRequiredBtnImg?: boolean;
}

const ActionHeader = (props: Props) => {
    const { heading, isbuttonRequired, handleClick, buttonName, buttonImg, className, isRequiredBtnImg } = props;
    return (
        <div className={`flex-center-between action-header-wrapper ${className}`}>

            <h3 className="h3 text-capitalize fw-600">{heading}</h3>

            {isbuttonRequired &&
                <button className='btn btn-secondary text-capitalize button-style' onClick={() => handleClick(isbuttonRequired)}>
                    {isRequiredBtnImg && <img src={buttonImg} alt={buttonName} />}
                    <span>{buttonName}</span>
                </button>
            }
        </div>
    )
}

export default ActionHeader;
